export const OrderStatusesMap = {
    all: { statusIn: '', statusNotIn: 'initial,created' },
    // Backup statuses
    // placed: {statusIn: 'placed,created,po_provided,po_payment_due,waiting_for_payment,re_manufacturing,on_hold,free_for_manufacturing,manufacturing,post_production,shipped,ready_for_shipping,ready_for_pickup,delivered,cancelled_by_user,cancelled_by_admin'},
    placed: { statusIn: '', statusNotIn: 'initial,created,waiting_for_review,firm_offer_sent' },
    quotes: { statusIn: 'waiting_for_review,firm_offer_sent', statusNotIn: '' },
    abandoned: { statusIn: 'initial', statusNotIn: '' },
} as const;
